function base64UrlDecode(str) {
  try {
    const pad = str.length % 4 === 2 ? '==' : str.length % 4 === 3 ? '=' : '';
    const b64 = str.replace(/-/g, '+').replace(/_/g, '/') + pad;
    const binary = globalThis.atob
      ? globalThis.atob(b64)
      : globalThis.Buffer.from(b64, 'base64').toString('binary');
    return decodeURIComponent(
      Array.from(binary)
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );
  } catch {
    return '';
  }
}

export function decodeJwt(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const payloadRaw = base64UrlDecode(parts[1]);
    const payload = JSON.parse(payloadRaw);
    return payload && typeof payload === 'object' ? payload : null;
  } catch {
    return null;
  }
}

export function getJwtUserId(claims) {
  return claims?.userId || claims?.sub || null;
}

export function getJwtRole(claims) {
  return claims?.role || claims?.roles || null;
}

export function getJwtDisplayName(claims, fallback = null) {
  return claims?.Name || claims?.name || claims?.sub || fallback;
}

export function isJwtExpired(claims, nowSeconds = Math.floor(Date.now() / 1000)) {
  if (!claims?.exp) return false;
  return nowSeconds >= Number(claims.exp);
}

export function willJwtExpireSoon(
  claims,
  thresholdSeconds = 300,
  nowSeconds = Math.floor(Date.now() / 1000),
) {
  if (!claims?.exp) return false;
  return Number(claims.exp) - nowSeconds <= thresholdSeconds;
}
